export const transactionCategories = [
  { value: 0, text: 'in', theme: 'neutral' },
  { value: 1, text: 'out', theme: 'neutral' },
  { value: 2, text: 'p2p', theme: 'neutral' },
  { value: 3, text: 'refund', theme: 'neutral' },
  { value: 4, text: 'chargeback', theme: 'neutral' },
  { value: 5, text: 'creditChargeback', theme: 'neutral' },
  { value: 6, text: 'lwCommission', theme: 'neutral' },
  { value: 7, text: 'lwFee', theme: 'neutral' },
  { value: 8, text: 'partnerCommission', theme: 'neutral' },
  { value: 9, text: 'cancelledMoneyOut', theme: 'neutral' }
];

export const transactionTypes = [
  { value: 0, text: 'in', theme: 'neutral' },
  { value: 1, text: 'out', theme: 'neutral' },
  { value: 2, text: 'p2p', theme: 'neutral' }
];
